import Axios from "axios";
import { ApiBaseUrl, ReportChequeURL, ReportURL } from "../config/config";
import {
  AddCreditRequest,
  AddCreditResponse,
  AddSupplierAddressRequest,
  AddSupplierAddressResponse,
  AddSupplierUsersResponse,
  DeactivateSupplierRequest,
  DeactivateSupplierResponse,
  EditSupplierAddressRequest,
  Filter,
  GetFinancialSuppliersForCreditRequestRequest,
  GetFinancialSuppliersForCreditRequestResponse,
  GetLoanTemplatesForCreditRequestRequest,
  GetOnlineInstallmentReportRequest,
  GetOnlineInstallmentReportResponse,
  GetSupplierInfoRequest,
  GetSuppliersCreditHistoryRequest,
  GetSuppliersCreditHistoryResponse,
  GetSuppliersInfoResponse,
  GetSuppliersResponse,
  addNewSupplierRequest,
  addNewSupplierResponse,
  getSupplierAddresesResponse,
  getSupplierUsersRequest,
  getSupplierUsersResponse,
  AddSupplierUserRequest,
  EditSupplierUserRequest,
  GetLoansReportResponse,
  GetSalesReportResponse,
  TableFilter,
  TableReportRequest,
  GetDelayedInstallmentsResponse,
  GetConsumedResourcesReportResponse,
  GetDeferredOnlineInstallmentsResponse,
} from "../models/report.model";
import { ApiResultModel } from "../models/common.model";
import { GetStatusResponse } from "../models/basicInformation.model";

export const GetSuppliersList = (): Promise<GetSuppliersResponse> => {
  return Axios.post<ApiResultModel<GetSuppliersResponse>>(
    ApiBaseUrl + ReportURL + "/GetSuppliers"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierInfo = async (
  data: GetSupplierInfoRequest
): Promise<GetSuppliersInfoResponse> => {
  return await Axios.post<ApiResultModel<GetSuppliersInfoResponse>>(
    ApiBaseUrl + ReportURL + "/GetSupplierInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeactivateSupplier = async (
  data: DeactivateSupplierRequest
): Promise<DeactivateSupplierResponse> => {
  return await Axios.post<ApiResultModel<DeactivateSupplierResponse>>(
    ApiBaseUrl + ReportURL + "/DeactivateSupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierCreditHistory = async (
  data: GetSuppliersCreditHistoryRequest
): Promise<GetSuppliersCreditHistoryResponse[]> => {
  return await Axios.post<ApiResultModel<GetSuppliersCreditHistoryResponse[]>>(
    ApiBaseUrl + ReportURL + "/GetSupplierCreditHistory",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetFinancialSuppliersForCreditRequest = async (
  data: GetFinancialSuppliersForCreditRequestRequest
): Promise<GetFinancialSuppliersForCreditRequestResponse[]> => {
  return await Axios.post<
    ApiResultModel<GetFinancialSuppliersForCreditRequestResponse[]>
  >(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/GetFinancialSuppliersForCreditRequest",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanTemplatesForCreditRequest = async (
  data: GetLoanTemplatesForCreditRequestRequest
): Promise<GetStatusResponse[]> => {
  return await Axios.post<ApiResultModel<GetStatusResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/GetLoanTemplatesForCreditRequest",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierUsers = async (
  data: getSupplierUsersRequest
): Promise<getSupplierUsersResponse[]> => {
  return await Axios.post<ApiResultModel<getSupplierUsersResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/GetSupplierUsers",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierAddreses = async (data: {
  supplierId: number;
}): Promise<getSupplierAddresesResponse[]> => {
  return await Axios.post<ApiResultModel<getSupplierAddresesResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/GetSupplierAddresses",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddCredit = async (
  data: AddCreditRequest
): Promise<AddCreditResponse> => {
  return await Axios.post<ApiResultModel<AddCreditResponse>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/AddCredit",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddNewSupplier = async (
  data: addNewSupplierRequest
): Promise<addNewSupplierResponse> => {
  const formData = new FormData();

  formData.append("isOfflineStore", JSON.stringify(data.isOfflineStore));
  formData.append("isOnlineStore", JSON.stringify(data.isOnlineStore));
  formData.append("isTopRated", JSON.stringify(data.isTopRated));

  formData.append("title", data.title!);
  formData.append("storeTitle", data.storeTitle!);
  formData.append("websiteUrl", data.websiteUrl!);

  formData.append("logo", data.logo);
  for (var i = 0; i < data.users.length; i++) {
    formData.append("users[" + i + "].firstName", data.users[i].firstName);
    formData.append("users[" + i + "].lastName", data.users[i].lastName);
    formData.append("users[" + i + "].mobileNo", data.users[i].mobileNo);
    formData.append("users[" + i + "].fullAccess", data.users[i].fullAccess);
    formData.append("users[" + i + "].cityId", data.users[i].cityId);
  }

  return Axios.post<ApiResultModel<addNewSupplierResponse>>(
    ApiBaseUrl + ReportURL + "/AddNewSupplier",
    formData
  ).then((result) => {
    return result.data.data;
  });
};

export const AddSupplierAddress = async (
  data: AddSupplierAddressRequest
): Promise<AddSupplierAddressResponse> => {
  return await Axios.post<ApiResultModel<AddSupplierAddressResponse>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/AddSupplierAddress",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const EditSupplierAddress = async (
  data: EditSupplierAddressRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/EditSupplierAddress",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteSupplierAddress = async (data: {
  supplierAddressId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/DeleteSupplierAddress",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddSupplierUsers = async (
  data: AddSupplierUserRequest
): Promise<AddSupplierUsersResponse> => {
  return await Axios.post<ApiResultModel<AddSupplierUsersResponse>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/AddSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const EditSupplierUsers = async (
  data: EditSupplierUserRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/EditSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteSupplierUsers = async (data: {
  id: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + ReportURL + "/DeleteSupplierUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetOnlineInstallmentReport = (
  data: GetOnlineInstallmentReportRequest
): Promise<ApiResultModel<GetOnlineInstallmentReportResponse[]>> => {
  return Axios.post<ApiResultModel<GetOnlineInstallmentReportResponse[]>>(
    ApiBaseUrl + "/api/Report" + "/GetOnlineInstallmentReport",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetOnlineInstallmentReportExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + "/api/Report" + "/GetOnlineInstallmentReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${data.cartableTitle ? data.cartableTitle : "گزارش اقساط آنلاین"} .xlsx`
    );
    document.body.appendChild(link);
    link.click();
  });
};

export const GetLoansReport = (
  data: GetOnlineInstallmentReportRequest
): Promise<ApiResultModel<GetLoansReportResponse[]>> => {
  return Axios.post<ApiResultModel<GetLoansReportResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetLoansReport",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ExportLoansReport = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + ReportChequeURL + "/ExportLoansReport",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` گزارش تسهیلات .xlsx`);

    document.body.appendChild(link);
    link.click();
  });
};
export const GetSalesReport = (
  data: GetOnlineInstallmentReportRequest
): Promise<ApiResultModel<GetSalesReportResponse[]>> => {
  return Axios.post<ApiResultModel<GetSalesReportResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetSalesReport",
    data
  ).then((result) => {
    return result.data;
  });
};

export const ExportSalesReport = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + ReportChequeURL + "/ExportSalesReport",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` گزارش فروش .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetDelayedInstallments = (
  data: TableReportRequest
): Promise<ApiResultModel<GetDelayedInstallmentsResponse[]>> => {
  return Axios.post<ApiResultModel<GetDelayedInstallmentsResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetDelayedInstallments",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetDelayedInstallmentsReportExcel = async (data: TableFilter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + ReportChequeURL + "/GetDelayedInstallmentsReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"گزارش اقساط معوق"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
export const GetConsumedResourcesReport = (
  data: any
): Promise<ApiResultModel<GetConsumedResourcesReportResponse[]>> => {
  return Axios.post<ApiResultModel<GetConsumedResourcesReportResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetConsumedResourcesReport",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetConsumedResourcesReportExcel = async () => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + ReportChequeURL + "/GetConsumedResourcesReportExcel",

    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"گزارش  مصرف منابع"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetDeferredOnlineInstallments = (
  data: TableReportRequest
): Promise<ApiResultModel<GetDeferredOnlineInstallmentsResponse[]>> => {
  return Axios.post<ApiResultModel<GetDeferredOnlineInstallmentsResponse[]>>(
    ApiBaseUrl + ReportChequeURL + "/GetDeferredOnlineInstallments",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetDeferredOnlineInstallmentsReportExcel = async (
  data: TableFilter
) => {
  return await Axios({
    method: "POST",
    url:
      ApiBaseUrl +
      ReportChequeURL +
      "/GetDeferredOnlineInstallmentsReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` گزارش اقساط آنلاین معوق .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
